import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";
import DashboardService from "../../../../services/OrderingServices/DashboardService";

const Widgets = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const response = await DashboardService.getList();

      const transformedData = [
        {
          label: "Total Categories",
          counter: response.categoryCount,
          icon: "ri-list-unordered",
          name: "View Categories",
          link: "/category-list",
          bg: "#FFFFFF",
          color: "#0D47A1",
        },
        {
          label: "Total Products",
          counter: response.productCount,
          icon: "ri-shopping-bag-line",
          name: "View Products",
          link: "/menu-item",
          bg: "#FFFFFF",
          color: "#1B5E20",
        },
        {
          label: "Total Orders",
          counter: response.orderCount,
          icon: "ri-clipboard-line",
          name: "View Orders",
          link: "/order",
          bg: "#FFFFFF",
          color: "#E65100",
        },
        {
          label: `Top Item: ${response.mostOrderedItem}`,
          counter: response.mostOrderedQuantity,
          icon: "ri-star-smile-line",
          name: "Top Ordered Item",
          bg: "#FFFFFF",
          color: "#4A148C",
        },
      ];

      setData(transformedData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Row>
      {data.map((item, key) => (
        <Col xl={6} md={6} lg={6} key={key} className="">
          <Card
            className="card-animate border-0 shadow-sm"
            style={{
              borderRadius: "1rem",
              transition: "0.3s ease-in-out",
              cursor: "pointer",
              background: item.bg,
              color: item.color,
            }}
            onClick={() => navigate(item.link)} // ✅ Whole block is clickable
            onMouseEnter={(e) =>
              (e.currentTarget.style.transform = "scale(1.03)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.transform = "scale(1)")
            }
          >
            <CardBody className="">
              <div className="d-flex align-items-center justify-content-between mb-2">
                <p
                  className="text-uppercase fw-semibold mb-0 text-truncate"
                  style={{ color: item.color }}
                >
                  {item.label}
                </p>
              </div>

              <div className="d-flex justify-content-between align-items-end mt-3">
                <div>
                  <h4
                    className="fs-3 fw-bold mb-1"
                    style={{ color: item.color }}
                  >
                    <CountUp
                      start={0}
                      end={item.counter}
                      duration={2.5}
                      separator=","
                    />
                  </h4>
                  <span
                    className="text-decoration-underline fs-13"
                    style={{ color: item.color }}
                  >
                    {item.name}
                  </span>
                </div>
                {/* Avatar Icon */}
                <div
                  className="d-flex align-items-center justify-content-center rounded-circle"
                  style={{
                    backgroundColor: `${item.color}15`, // lighter tint
                    width: "32px",
                    height: "32px",
                  }}
                >
                  <i
                    className={`fs-6 ${item.icon}`} // smaller & subtle
                    style={{
                      color: item.color,
                    }}
                  ></i>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default Widgets;
